import React from 'react';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkIcon, UitkIconProps } from 'uitk-react-icons';
import gaLogger from 'src/utils/ga-logger';
import { appendMcicid, checkValue } from 'src/components/common/helper';
interface PrimaryButtonProps {
  text: string;
  exClass?: string;
  styles?: React.CSSProperties;
  isFullWidth?: boolean;
  url?: string;
  target?: '' | '_blank';
  tag?: 'a' | 'button';
  onClickEvent?: (evt?: any) => any | undefined;
  expTracking?:
    | {
        templateType: string;
        campaignUrl: string;
        mainUrl: string;
        referrerId: string;
      }
    | undefined;
  gaTracking:
    | {
        eventCategory: string;
        eventAction: string;
        eventLabel: string;
      }
    | undefined;
  icon?: UitkIconProps;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = props => {
  const {
    text,
    exClass = '',
    styles,
    isFullWidth = false,
    tag = 'button',
    url,
    target = '',
    onClickEvent,
    icon,
    expTracking
  } = props;
  const buttonClickEvent = e => {
    if (onClickEvent) {
      onClickEvent(e);
    }

    const { gaTracking } = props;
    if (gaTracking) {
      const { eventCategory, eventAction, eventLabel } = gaTracking;
      gaLogger.logGa(eventCategory, eventAction, eventLabel);
    }
    if (url) {
      let urlWithTracking = url;
      if (expTracking && checkValue(expTracking.templateType)) {
        const { templateType, campaignUrl, mainUrl, referrerId = '' } = expTracking;
        urlWithTracking = appendMcicid(url, templateType, campaignUrl, mainUrl, referrerId);
      }
      if (target === '') { 
        window.location.href = urlWithTracking;
      } else { 
        window.open(urlWithTracking, target);
      }
    }
  };
  return (
    <UitkPrimaryButton
      type="button"
      tag={tag}
      className={exClass}
      isFullWidth={isFullWidth}
      onClick={e => buttonClickEvent(e)} 
      style={styles}
    >
      <span>{text}</span>
      {icon && <UitkIcon name={icon.name} className={icon.className} />}
    </UitkPrimaryButton>
  );
};

export { PrimaryButtonProps, PrimaryButton };
